import React from "react"

import { PageLink, PathLink, ExternalLink } from '../ui';

export const NavLink = ({ _type, ...rest }) => {
  const LinkComponent = () => {
    switch (_type) {
      case 'pageLink':
        return <PageLink activeClass="border-current border-b font-bold" {...rest} />;
      case 'pathLink':
        return <PathLink activeClass="border-current border-b font-bold" {...rest} />;
      case 'externalLink':
        return <ExternalLink {...rest} />;

      default:
        return null;
    }
  }
  return <LinkComponent />
}
